const items = [
  "Pola Pikir Adalah Aset",
  "Kelimpahan Dimulai dari Dalam",
  "Investasi Terbaik: Diri Sendiri",
  "Satu Keputusan, Hidup Berubah",
  "Uang Mengikuti Nilai Diri",
];

export const Marquee = () => (
  <div className="relative border-y border-[#211B10]/10 py-8 overflow-hidden bg-[#FBF7EE]" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-32 pr-32">
          {items.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center gap-32">
              <span className="font-display italic text-2xl md:text-3xl text-[#211B10]/55">{item}</span>
              <span className="w-2 h-2 rotate-45 bg-[#A67C1E]/50" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
